import { EquipmentSocket, TroopTrait } from "./JsonDefinitions.ts";

export enum HeroSex {
    Male,
    Female
}

export enum HeroTask {
    Guard,
    Attack,
    Production,
    Population,
    Idle
}

export interface IHero {
    id: number;
    stars: number;
    trait: TroopTrait;
    sex: HeroSex;
    name: string;
    /**
     * Hero base effects array with 5 items. The last one in the array is the biased effect depending on trait and sex.
     * The biased effect value is always greater then other effect values.
     * Note: effects get activated with stars, 1 star hero has only the first effect activated, 2 stars hero has the first two effects activated and so on.
     */
    effects: IEffect[];

    /**
     * Random effect values that are added to the base effects. The values depend on the hero stars level.
     */
    effectsRng: number[];

    task: HeroTask; //"guard" | "attack" | "production" | "population" | "idle";

    equipment: EquipmentSlot[];

    experience: number;
    distributionPoints: number;
}

export interface IEffect {
    type: "attack" | "defense" | "armor" | "hp" | "speed" | "production" | "population";
    value: number;
}

export type EquipmentSlot = {
    socket: EquipmentSocket;
    equipmentId: number;
}